module.exports = __webpack_public_path__ + "static/media/level-background-fill.81dbd292.svg";